import { graphql } from '@/generated/gql';

export const DEMAND_DETAIL_MUTATION = graphql(/* GraphQL */ `
  mutation ContractDemandDetailUnifiedUpdate(
    $id: UUID!
    $demandData: TsrctDemandUpdateInput!
    $competitiveBiddingRuleData: TsrctCompetitiveBiddingRuleInput
  ) {
    tesseract {
      demand(id: $id) {
        update(data: $demandData) {
          id
          capabilityIds
          responsibleUserIds
          demandRequest {
            id
            sourceReferences {
              internalId
              sourceReference
              sourceSystem {
                id
                name
              }
              isPrimary
            }
          }
          permissions {
            write
          }
        }
        competitiveBiddingRule {
          update(data: $competitiveBiddingRuleData) {
            id
            variant
            deadline
          }
        }
      }
    }
  }
`);

export const CONTRACT_DEMAND_UPDATE_MUTATION = graphql(/* GraphQL */ `
  mutation ContractDemandUpdate($id: UUID!, $contractDemandData: TsrctContractDemandDetailsInput!) {
    tesseract {
      contractDemand(id: $id) {
        update(data: $contractDemandData) {
          id
          priority
          sequenceNumber
          competitiveBiddingRule {
            id
            variant
            biddingPeriodDays
            deadline
            deadlineExceeded
          }
          createdAt
          updatedAt
          responsibleUserId
          tagIds
          demandRequest {
            id
            commodityGroupId
            createdAt
            currency
            incoTermsId
            requestedAt
            totalValue
            validityPeriod {
              from
              to
            }
            summary
            paymentTermsId
            lineItems {
              id
              baselinePricePerUnit
              commodityGroupId
              commodityId
              createdAt
              deliveryLocationId
              description
              minimumOrderQuantity
              quantity
              title
              unitId
            }
          }
        }
      }
    }
  }
`);
